<template>
  <div>
    <Header
      v-if="!(path === '/mIndex') && !(path === '/mContact') 
      && !(path === '/mNav') && !(path === '/mLaw') 
      && !(path === '/mProject') && !(path === '/mItems')
      && !(path === '/mInformation') && !(path === '/mAboutour')
      && !(path === '/mTrain') && !(path === '/mNews')
      && !(path === '/mNewsDetail') && !(path === '/mContact')
      && !(path === '/mDouble') && !(path === '/mCopyright')"
    ></Header>
    <router-view></router-view>
    <Footer
      v-if="!(path === '/mIndex') && !(path === '/mContact')
       && !(path === '/mNav') && !(path === '/mLaw')
       && !(path === '/mProject') && !(path === '/mItems')
       && !(path === '/mInformation') && !(path === '/mAboutour')
       && !(path === '/mTrain') && !(path === '/mNews')
       && !(path === '/mNewsDetail') && !(path === '/mContact')
       && !(path === '/mDouble') && !(path === '/mCopyright')"
    ></Footer>
  </div>
</template>

<script>
import Header from "./components/header.vue";
import Footer from "./components/footer.vue";
export default {
  props: {},
  data() {
    return {
      path: "",
    };
  },
  updated() {},
  mounted() {
    this.path = this.$route.path;
  },
  methods: {},
  components: {
    Header,
    Footer,
  },
  watch: {
    $route(to, from) {
      this.path = to.path;
    },
  },
};
</script>

<style>
.main{
  margin-top: 136px;
}
.cmain{
  margin-top: 3.4rem;
}
.el-carousel__container{
  height: 40rem !important;
}
ul li {
  list-style: none;
}
a {
  text-decoration: none;
  color: black;
}
html {
  font-size: 100px;
  color: #000;
}
body {
  margin: 0;
  padding: 0;
}
.navvv:hover {
  cursor: pointer;
}
.el-submenu__title {
  height: 3.4rem !important;
  line-height: 3.4rem !important;
  font-family: PingFang SC Medium, PingFang SC Medium-Medium !important;
  color: #221815 !important;
  font-size: 0.75rem !important;
  border-top: 0.02rem solid #bfbfbf !important;
}
.my-top-msg{
  z-index: 9999 !important;
  
}
.my-top-msg i{
   font-size: 30px !important;
}
</style>

